export default __webpack_public_path__ + "static/media/PaintingPenArtSchool-3.fdd543fc.jpg";